import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {LOCALSTORAGE_KEY_OPTION, OPTION_TYPE, SEUNGJO_DISP_TYPE} from '../../defines/client.const';
import {STAR_FILTER} from '../../defines/protocol';
import {LIST_HELP_FLAG, ListHelpService} from '../list-help/list-help.service';

const DEFAULT_START_ANIM = true;
const DEFAULT_AUTO_PLAY = true;
const DEFAULT_LARGEMODE = false;
const DEFAULT_SHOWSASEUNG = true;
const DEFAULT_WORDLEVEL = STAR_FILTER.ALL;
const DEFAILT_SEUNGJO_DISP_TYPE = SEUNGJO_DISP_TYPE.SYMBOL;


export type OPTION_ITEM = {
  type: OPTION_TYPE,
  id: string;
  title: string;
  msg: string;
  options: Array<{
    name: string | null;
    value: unknown;
    etc?: string;     // 모바일 앱에서 css 관련
    css?: string;      // 책상형 웹에서 css 관련
  }>;
  getter: () => unknown;  // 옵션의 현재 값을 가져오는 함수.
  setter: (_: any) => void; // 옵션 설정 시 불려지는 함수.
};


@Injectable({
  providedIn: 'root'
})
export class OptionService {

  /**
   * 단어 목록에 표시되는 옵션이 설정.
   */
  public optionItems: Array<OPTION_ITEM> = [
/*
    // 책상형 홈페이지에서는 시작영상 효시 안하기로 함.
    {
      type: OPTION_TYPE.START_ANIM,
      id: 'start-anim',
      title: '시작 영상 표시',
      msg: '앱 시작 영상을 재생 합니다.',
      options: [
        {
          name: '끄기',
          value: false,
        },
        {
          name: '켜기',
          value: true,
        },
      ],
      getter: () => this.startAnim,
      setter: (v: boolean) => { this.startAnim = v; },
    },
*/
    {
      type: OPTION_TYPE.AUTO_PLAY,
      id: 'auto-play',
      title: '소리 자동 재생',
      msg: "단어의 상세 화면에 들어 갈 때에, 자동으로 단어의 발음을 재생 합니다. 처음에는 세 번씩 자동으로 들리고 그 다음에는 단추를 누를 때마다 한 번씩 들립니다.<br>'끄기'를 해도 수동으로 눌러서 소리를 들을 수 있습니다.",
      options: [
        {
          name: '켜기',
          value: true,
        },
        {
          name: '끄기',
          value: false,
        },
      ],
      getter: () => this.autoPlay,
      setter: (v: boolean) => { this.autoPlay = v; },
    },
    {
      type: OPTION_TYPE.SEUNGJO_DISP,
      id: 'seungjo-disp-type',
      title: '성조 표시 방식',
      msg: '각 자의 특성에 따라서 음 높이가 잘 받아들여지는 여러 방식을 만들었습니다. 지정 한 방식으로 성조가 표시가 됩니다.',
      options: [
        {
          name: '기호',
          value: SEUNGJO_DISP_TYPE.SYMBOL,
        },
        {
          name: '수자數字',
          value: SEUNGJO_DISP_TYPE.NUMBER,
        },
        {
          name: '색',
          value: SEUNGJO_DISP_TYPE.COLOR,
        },
      ],
      getter: () => this.seungjoDispType,
      setter: (v: SEUNGJO_DISP_TYPE) => { this.seungjoDispType = v; }
    },
    {
      type: OPTION_TYPE.SHOW_SASEUNG,
      id: 'show-saseung',
      title: '사 성四聲 표시',
      msg: '문자文字 위에 사 성을 표시를 합니다.',
      options: [
        {
          name: '표시',
          value: true,
        },
        {
          name: '무 표시',
          value: false,
        },
      ],
      getter: () => this.showSaseung,
      setter: (v: boolean) => { this.showSaseung = v; },
    },
    // 나중에 복구할 수 있으니 지우지 말 것.
    // {
    //   // 단어 난이도 필터
    //   type: OPTION_TYPE.WORD_LEVEL,
    //   id: 'word-level',
    //   title: '단어 난이도 표시',
    //   msg: '지정 한 난이도를 포함해서 더 쉬운 단어만 표시가 됩니다.<br>별이 많을 수록 어렵거나 잘 쓰이지 않는 단어입니다.',
    //   options: [
    //     {
    //       name: '전체',
    //       value: STAR_FILTER.ALL,
    //     },
    //     // {
    //     //   name: null,
    //     //   value: STAR_FILTER.FOUR,
    //     //   etc: 'star star4',
    //     //   css: 'star type-4'
    //     // },
    //     {
    //       name: null,
    //       value: STAR_FILTER.THREE,
    //       etc: 'star star3',
    //       css: 'star type-3'
    //     },
    //     {
    //       name: null,
    //       value: STAR_FILTER.TWO,
    //       etc: 'star star2',
    //       css: 'star type-2'
    //     },
    //     {
    //       name: null,
    //       value: STAR_FILTER.ONE,
    //       etc: 'star star1',
    //       css: 'star type-1'
    //     },
    //   ],
    //   getter: () => this.wordLevel,
    //   setter: (v: STAR_FILTER) => { this.wordLevel = v; }
    // },
    {
      type: OPTION_TYPE.LARGE_MODE,
      id: 'large-mode',
      title: '글자 크기',
      msg: '글자 크기를 크거나 작게 변경을 합니다.',
      options: [
        {
          name: '보통',
          value: false,
        },
        {
          name: '크게',
          value: true,
        },
      ],
      getter: () => this.largeMode,
      setter: (v: boolean) => { this.largeMode = v; },
    },
  ] ;

  constructor(
    private listHelpSvc: ListHelpService,
  ) {
    this.load();
  }

  private optionChange: BehaviorSubject<OPTION_TYPE> = new BehaviorSubject<OPTION_TYPE>(OPTION_TYPE.NONE);
  public getState(): Observable<OPTION_TYPE> {
    return this.optionChange.asObservable();
  }

  public GetOptionItem(type: OPTION_TYPE): OPTION_ITEM | null {
    return this.optionItems.find(value => value.type === type) || null;
  }

  // tslint:disable-next-line:variable-name
  private _startAnim: boolean = DEFAULT_START_ANIM;
  public get startAnim(): boolean {
    return this._startAnim;
  }
  public set startAnim(value: boolean) {
    if (this._startAnim !== value) {
      this._startAnim = value;
      this.save();
      this.listHelpSvc.SetFlag(LIST_HELP_FLAG.START_ANIM);
      this.optionChange.next(OPTION_TYPE.START_ANIM);
    }
  }

  // tslint:disable-next-line:variable-name
  private _autoPlay = DEFAULT_AUTO_PLAY;
  public get autoPlay(): boolean {
    return this._autoPlay;
  }
  public set autoPlay(value: boolean) {
    if (this._autoPlay !== value) {
      this._autoPlay = value;
      this.save();
      this.listHelpSvc.SetFlag(LIST_HELP_FLAG.AUTO_PLAY);
      this.optionChange.next(OPTION_TYPE.AUTO_PLAY);
    }
  }

  // tslint:disable-next-line:variable-name
  private _largeMode = DEFAULT_LARGEMODE;
  public get largeMode(): boolean {
    return this._largeMode;
  }
  public set largeMode(value: boolean) {
    if (this._largeMode !== value) {
      this._largeMode = value;
      this.save();
      this.listHelpSvc.SetFlag(LIST_HELP_FLAG.LARGE_FONT);
      this.optionChange.next(OPTION_TYPE.LARGE_MODE);
    }
  }


  // tslint:disable-next-line:variable-name
  private _showSaseung = DEFAULT_SHOWSASEUNG;
  public get showSaseung(): boolean {
    return this._showSaseung;
  }
  public set showSaseung(value: boolean) {
    console.warn('showSaseung', value);

    if (this._showSaseung !== value) {
      this._showSaseung = value;
      this.save();
      // this.listHelpSvc.SetFlag()
      this.optionChange.next(OPTION_TYPE.SHOW_SASEUNG);
    }
  }


  // private _wordLevel = DEFAULT_WORDLEVEL;
  // public get wordLevel(): STAR_FILTER {
  //   return this._wordLevel;
  // }
  // public set wordLevel(value: STAR_FILTER) {
  //   if (this._wordLevel !== value) {
  //     this._wordLevel = value;
  //     this.save();
  //     // this.listHelpSvc.SetFlag()
  //     this.optionChange.next(OPTION_TYPE.WORD_LEVEL);
  //   }
  // }
  public get wordLevel(): STAR_FILTER {
    return STAR_FILTER.ALL;
  }
  public set wordLevel(value: STAR_FILTER) {
  }


  // tslint:disable-next-line:variable-name
  private _seungjoDispType = DEFAILT_SEUNGJO_DISP_TYPE;
  public get seungjoDispType(): SEUNGJO_DISP_TYPE {
    return this._seungjoDispType;
  }
  public set seungjoDispType(value: SEUNGJO_DISP_TYPE) {
    if (this._seungjoDispType !== value) {
      this._seungjoDispType = value;
      this.save();
      // this.listHelpSvc.SetFlag()
      this.optionChange.next(OPTION_TYPE.SEUNGJO_DISP);
    }
  }


  toJSON(): any {
    return {
      start_anim:     this._startAnim,
      auto_play:      this._autoPlay,
      large_mode:     this._largeMode,
      show_saseung:   this._showSaseung,
      // word_level:     this._wordLevel,
      seungjo_disp_type: this._seungjoDispType,
    };
  }

  public load(): void {
    const txtOptions = localStorage.getItem(LOCALSTORAGE_KEY_OPTION);
    const options = txtOptions ? JSON.parse(txtOptions) : null;

    this._startAnim   = (options && options.start_anim) ?? DEFAULT_START_ANIM;
    this._autoPlay    = (options && options.auto_play) ?? DEFAULT_AUTO_PLAY;
    this._largeMode   = (options && options.large_mode) ?? DEFAULT_LARGEMODE;
    this._showSaseung = (options && options.show_saseung) ?? DEFAULT_SHOWSASEUNG;
    // this._wordLevel   = (options && options.word_level) ?? DEFAULT_WORDLEVEL;
    this._seungjoDispType = (options && options.seungjo_disp_type) ?? DEFAILT_SEUNGJO_DISP_TYPE;

    console.log('OptionService::load()', this);
  }

  public save(): void {
    localStorage.setItem(LOCALSTORAGE_KEY_OPTION, JSON.stringify(this));
  }
}
